export default __webpack_public_path__ + "static/favicon-87d07e1d84c014e2f3d77fff96bd0c7d.png";